var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"test"}},[_c('h1',{staticStyle:{"text-align":"center !important","color":"red"}},[_vm._v("Test for print html")])])])
}]

export { render, staticRenderFns }